// /src/App.js
import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

// Hooks
import { useThemeVars, useFullViewportBackground } from './hooks/useTheme';

// Components
import Nav from './components/Nav';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ToolsPage from './pages/ToolsPage';
import ToolDetailPage from './pages/ToolDetailPage';
import OpenSourcePage from './pages/OpenSourcePage';
import PlaybooksPage from './pages/PlaybooksPage';
import ContactPage from './pages/ContactPage';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  // Persist theme across reloads
  const [isDark, setIsDark] = useState(() => {
    const stored = localStorage.getItem('isDark');
    if (stored !== null) return stored === 'true';
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    localStorage.setItem('isDark', String(isDark));
  }, [isDark]);

  const themeVars = useThemeVars(isDark);
  useFullViewportBackground(themeVars, [isDark]);

  return (
    <div className="flex flex-col min-h-screen w-full" style={themeVars}>
      <Nav isDark={isDark} setIsDark={setIsDark} />

      <main className="flex-1 w-full min-h-screen bg-[var(--bg)] text-[var(--text)]">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/tools/:slug" element={<ToolDetailPage />} />
            <Route path="/open-source" element={<OpenSourcePage />} />
            <Route path="/playbooks" element={<PlaybooksPage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </main>

      <Footer />
    </div>
  );
}